import React, { useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import JsonView from "@uiw/react-json-view";
import { toast } from "react-toastify";
import { MdCopyAll } from "react-icons/md";
import { FaSpinner } from "react-icons/fa";
import DragDrop from "../../components/wokeloFileUploader/dropZone";

const GeneralScrapperPdf = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [response, setResponse] = useState(null);
  const [isScrapping, setIsScrapping] = useState(false);
  const [errorFiles, setErrorFiles] = useState([]);
  const axios = useAxiosInstance();

  const handleFileUpload = (files) => {
    setResponse(null);
    setUploadedFiles(files);
  };

  const setFileError = (error) => {
    toast.error(`File upload error: ${error.message}`);
  };

  const handleScrap = async () => {
    if (uploadedFiles.length === 0) {
      toast.error("Please upload a PDF file first");
      return;
    }
    if (isScrapping) return;

    setIsScrapping(true);
    setResponse(null);

    try {
      const firstFile = uploadedFiles[0];
      if (!firstFile) {
        toast.error("No file found to upload");
        return;
      }

      const fileToSend = firstFile instanceof File
        ? firstFile
        : new File([firstFile], firstFile?.name || "upload.pdf", {
            type: firstFile?.type || "application/pdf"
          });

      const formData = new FormData();
      formData.append("file", fileToSend);

      const apiResponse = await axios.post('assets/get_pdf_scrapping_result/', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setResponse(apiResponse.data);
      toast.success("PDF scrapped successfully!");
    } catch (error) {
      toast.error("Failed to scrap PDF");

      // const mockResponse = {
      //   "success": true,
      //   "file_name": "report_1004405.pdf",
      //   "file_size": 360513,
      //   "scraping_result": [
      //     {
      //       "title": "report_1004405.pdf",
      //       "text": [
      //         {
      //           "content": "Sample PDF content...",
      //           "num_words": 100,
      //           "heading": ["# Sample Heading"]
      //         }
      //       ],
      //       "landscape": false,
      //       "total_words": 100
      //     },
      //     {
      //       "page_count": 6,
      //       "failed_pages": 0,
      //       "status": "scrapped"
      //     }
      //   ]
      // };
      // setResponse(mockResponse);
      // toast.success("PDF scrapped successfully (using fallback)!");
    } finally {
      setIsScrapping(false);
    }
  };

  return (
    <div className="mr-4 p-3 my-5 border rounded-lg bg-white">
      <p className="text-2xl text-black font-medium mb-4">General Scraper PDF</p>
      
      <div className="mb-3 text-sm">
        {isScrapping ? (
          <span className="text-blue-600 flex items-center gap-2">
            <FaSpinner className="animate-spin" /> Scrapping PDF…
          </span>
        ) : uploadedFiles.length ? (
          <span className="text-green-700">
            Ready to scrap: {uploadedFiles[0]?.name || "1 file"}
          </span>
        ) : (
          <span className="text-gray-500">No file selected</span>
        )}
      </div>
      
      <div className="mb-6 w-full">
        <DragDrop
          types={["pdf"]}
          onChange={handleFileUpload}
          loading={false}
          onError={setFileError}
          setErrorFiles={setErrorFiles}
          disabled={isScrapping}
        />
      </div>
      
      <button
        onClick={handleScrap}
        disabled={isScrapping || uploadedFiles.length === 0}
        className="px-3 my-3 py-3 bg-black rounded-lg text-white disabled:bg-[#b6b6b6] flex items-center gap-2"
      >
        {isScrapping && <FaSpinner className="animate-spin" />}
        {isScrapping ? "Scrapping..." : "Scrap PDF"}
      </button>
      
      {response && (
        <div className="grid grid-cols-1 gap-2 mt-6">
          <div className="mt-3 h-[60vh] overflow-y-auto bg-slate-100 p-4 rounded-lg">
            <div className="flex justify-end w-full cursor-pointer mb-2">
              <MdCopyAll
                onClick={() => {
                  navigator.clipboard.writeText(JSON.stringify(response));
                  toast.success('Response copied to clipboard');
                }}
              />
            </div>
            <JsonView
              shortenTextAfterLength={0}
              value={response.scraping_result}
              displayObjectSize={false}
              displayDataTypes={false}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default GeneralScrapperPdf;